import React, { useState } from "react";
import styled from "@emotion/styled";
import { ForestTile, ForestTileInner } from "..";
import { ForestModalInvestor } from "../ForestModals/ForestModalInvestor";

const Image = styled.img`
  max-width: 100%;
`;

export const ForestTileInvestor = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <ForestTile onClick={() => setIsModalOpen(true)} data-testid="tile">
        <ForestTileInner>
          <Image src="/images/app/forest/investor.svg" alt="Investor" />
        </ForestTileInner>
      </ForestTile>
      {isModalOpen && (
        <ForestModalInvestor
          closePopup={() => setIsModalOpen(false)}
          isOpen={isModalOpen}
        />
      )}
    </>
  );
};
